export default __webpack_public_path__ + "static/media/clientSeven.9dd2f4b1.png";